export default function Inner(props) {
  return (
    <div className="w-11/12 max-w-[42em] mx-auto h-full">{props.children}</div>
  );
}
